import { render } from "./ProductImageCard.vue?vue&type=template&id=3bb1c7cb&scoped=true"
import script from "./ProductImageCard.vue?vue&type=script&lang=js"
export * from "./ProductImageCard.vue?vue&type=script&lang=js"

import "./ProductImageCard.vue?vue&type=style&index=0&id=3bb1c7cb&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bb1c7cb"]])

export default __exports__